import React, { useContext, useEffect, useRef, useState } from "react";
import { RiArrowRightSLine, RiArrowLeftSLine } from "react-icons/ri";

import "./ImageCrousel.css";
import { Theme } from "../App";
import { useFetcher } from "react-router-dom";

function ImageCrousel({ images }) {
  const { theme } = useContext(Theme);
  const [hasMounted, setHasMounted] = useState(false);

  const firstRef = useRef(null);
  const secondRef = useRef(null);
  const thirdRef = useRef(null);
  
  const firstRef1 = useRef(null);
  const secondRef1 = useRef(null);
  const thirdRef1 = useRef(null);

  let positions = [firstRef, secondRef, thirdRef];
  

  useEffect(()=>{
    console.log('theme changed')
    firstRef.current.style.rotate= "0 1 0 -35deg";
    firstRef.current.style.translate= "0% 0% 0px";
    firstRef.current.style.filter= "blur(4px)";
    firstRef.current.style.zIndex= "0";
    
    
    
    secondRef.current.style.rotate= "0 1 0 0deg";
    secondRef.current.style.translate= "0 0 200px";
    secondRef.current.style.filter= "none";
    secondRef.current.style.zIndex= "2";
    
    thirdRef.current.style.rotate= "0 1 0 35deg";
    thirdRef.current.style.translate= "0% 0% 0px";
    thirdRef.current.style.filter= "blur(4px)";
    thirdRef.current.style.zIndex= "-2";
    

  },[theme])

  function adjustTranslate(
    element,
    xChange,
    yChange,
    zChange,
    zRotationChange,
    order
  ) {
    // Get the current translate value
    let currentTranslate = element.style.translate;
    let currentRotation = element.style.rotate;
  
    // Split the value to get x, y, and z components
    let translateParts = currentTranslate.split(" ");
    let rotationStr = currentRotation.split(" ");

    // Parse and update each part
    let x = parseFloat(translateParts[0]);
    let y = parseFloat(translateParts[1]);
    let z = parseFloat(translateParts[2]);

    let currentDegree = parseFloat(rotationStr[3]);
    console.log(x, y, z, currentDegree);

    x ? (x += xChange) : (x = xChange);
    y ? (y += yChange) : (y = yChange);
    z ? (z += zChange) : (z = zChange);
    currentDegree
      ? (currentDegree += zRotationChange)
      : (currentDegree = zRotationChange);

    if (order == 2) {
      element.style.translate = `${x}% ${y}px ${z}px`;
      element.style.rotate = `0 1 0 ${currentDegree}deg`;
      console.log("Translation : ",element.style.translate)
      console.log("Rotation : ",element.style.rotate)
    } else {
      element.style.rotate = `0 1 0 ${currentDegree}deg`;
      element.style.translate = `${x}% ${y}px ${z}px`;
      console.log("Translation : ",element.style.translate)
      console.log("Rotation : ",element.style.rotate)
    }
  }

 


  const moveRight = () => {
    positions[0].current.style.zIndex = "2";
    positions[0].current.style.filter = "none";

    positions[1].current.style.zIndex = "0";
    positions[1].current.style.filter = "blur(4px)";

    positions[2].current.style.zIndex = "-2";
    positions[2].current.style.filter = "blur(4px)";

    adjustTranslate(positions[0].current, 100, 0, 200, 0, 1);
    adjustTranslate(positions[1].current, 100, 0, -200, 35, 2);
    adjustTranslate(positions[2].current, -200, 0, 0, -35, 2);

    let temp2 = positions[2];

    positions[2] = positions[1];
    positions[1] = positions[0];
    positions[0] = temp2;
  };

  const moveLeft = () => {
    positions[0].current.style.zIndex = "-2";
    positions[0].current.style.filter = "blur(4px)";

    positions[1].current.style.zIndex = "0";
    positions[1].current.style.filter = "blur(4px)";

    positions[2].current.style.zIndex = "2";
    positions[2].current.style.filter = "none";

    adjustTranslate(positions[0].current, 200, 0, 0, 35, 1); // First card move left
    adjustTranslate(positions[1].current, -100, 0, -200, -35, 2); // Second card move left
    adjustTranslate(positions[2].current, -100, 0, 200, 0, 3); // Third card move left

    // Cycle the positions array in reverse order
    let temp1 = positions[0];
    let temp2 = positions[1];

    positions[0] = positions[1];
    positions[1] = positions[2];
    positions[2] = temp1;
  };

  return (
    <div className="Image-crousel-comp">
      <RiArrowLeftSLine
        size={"25px"}
        onClick={moveLeft}
        className={`left-arrow left-arrow-${theme}`}
      />

      <div
        className="first-card"
        ref={firstRef}
        // style={{ rotate: "0 1 0 -35deg" }}
      >
        <img src={images[1]} alt="" />
      </div>
      <div
        className="second-card"
        ref={secondRef}
        // style={{ translate: "0 0 200px " }}
      >
        <img src={images[0]} alt="" />
      </div>
      <div
        className="third-card"
        ref={thirdRef}
        // style={{ rotate: "0 1 0 35deg" }}
      >
        <img src={images[2]} alt="" />
      </div>

      <RiArrowRightSLine
        size={"25px"}
        onClick={moveRight}
        className={`right-arrow right-arrow-${theme}`}
      />
    </div>
  );
}

export default ImageCrousel;
